import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingCTA from './components/FloatingCTA';

// Pages
import Home from './pages/Home';
import Fagomraader from './pages/Fagomraader';
import FagomraadeDetail from './pages/FagomraadeDetail';
import OmMig from './pages/OmMig';
import Kontakt from './pages/Kontakt';
import Nyheder from './pages/Nyheder';
import NyhedDetail from './pages/NyhedDetail';
import Privatlivspolitik from './pages/Privatlivspolitik';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col bg-white text-slate-800 font-sans selection:bg-[#1A5B69] selection:text-white">
        <ScrollToTop />
        <Header />

        <main className="grow">
          <Routes>
            {/* Forside */}
            <Route path="/" element={<Home />} />

            {/* Fagområder Oversigt */}
            <Route path="/fagomraader" element={<Fagomraader />} />
            <Route path="/fagomraader/" element={<Fagomraader />} />

            {/* Fagområder Undersider */}
            <Route path="/fagomraader/:slug" element={<FagomraadeDetail />} />
            <Route path="/fagomraader/:slug/" element={<FagomraadeDetail />} />

            {/* Om mig */}
            <Route path="/om-mig" element={<OmMig />} />
            <Route path="/om-mig/" element={<OmMig />} />

            {/* Kontakt */}
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/kontakt/" element={<Kontakt />} />

            {/* Nyheder & Blog */}
            <Route path="/nyheder" element={<Nyheder />} />
            <Route path="/nyheder/" element={<Nyheder />} />
            <Route path="/emner/blog" element={<Nyheder />} />
            <Route path="/emner/blog/" element={<Nyheder />} />

            {/* Nyhedsartikler */}
            <Route path="/eksempel-paa-indlaeg-3" element={<NyhedDetail fixedSlug="eksempel-paa-indlaeg-3" />} />
            <Route path="/eksempel-paa-indlaeg-3/" element={<NyhedDetail fixedSlug="eksempel-paa-indlaeg-3" />} />
            <Route path="/eksempel-paa-indlaeg-2-2" element={<NyhedDetail fixedSlug="eksempel-paa-indlaeg-2-2" />} />
            <Route path="/eksempel-paa-indlaeg-2-2/" element={<NyhedDetail fixedSlug="eksempel-paa-indlaeg-2-2" />} />
            <Route path="/eksempel-paa-indlaeg-2-2-2" element={<NyhedDetail fixedSlug="eksempel-paa-indlaeg-2-2-2" />} />
            <Route path="/eksempel-paa-indlaeg-2-2-2/" element={<NyhedDetail fixedSlug="eksempel-paa-indlaeg-2-2-2" />} />
            <Route path="/nyheder/:slug" element={<NyhedDetail />} />
            <Route path="/nyheder/:slug/" element={<NyhedDetail />} />

            {/* Privatlivspolitik */}
            <Route path="/privatlivspolitik" element={<Privatlivspolitik />} />
            <Route path="/privatlivspolitik/" element={<Privatlivspolitik />} />
            <Route path="/wp-content/uploads/Privatlivspolitisk-Advokatfirmaet-Kopp-ApS.pdf" element={<Privatlivspolitik />} />

            {/* Fejlsider */}
            <Route path="/403" element={<Forbidden />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
        <FloatingCTA />
      </div>
    </HelmetProvider>
  );
}
